<template>
  <div class="page-header-index-wide">
    <a-row>
      <a-col :span="24" style="background:#fff">
        <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
          <a-card :loading="loading" :bordered="false" title="每月接单量统计" :style="{ marginTop: '24px' }">
            <bar :dataSource="barData"/>
            <h5>单位：单</h5>
          </a-card>
        </a-col>
        <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
          <a-card :loading="loading" :bordered="false" title="维修员接单排行榜" :style="{ marginTop: '24px' }">
            <rank-list :list="rankList"/>
          </a-card>
        </a-col>
      </a-col>
    </a-row>
    
    <a-row :style="{ marginTop: '24px' }">
      <a-col :span="24" style="background:#fff">
        <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
          <a-card :loading="loading" :bordered="false" title="每月耗费统计" :style="{ marginTop: '24px' }">
            <line-chart-multid :fields="visitFields" :dataSource="visitInfo"></line-chart-multid>
            <h5>单位：元</h5>
          </a-card>
        </a-col>
        <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24">
          <a-card :loading="loading" :bordered="false" title="材料耗材排行榜" :style="{ marginTop: '24px' }">
            <rank-list :list="rankList2"/>
          </a-card>
        </a-col>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import ChartCard from '@/components/ChartCard'
  import ACol from "ant-design-vue/es/grid/Col"
  import ATooltip from "ant-design-vue/es/tooltip/Tooltip"
  import MiniArea from '@/components/chart/MiniArea'
  import MiniBar from '@/components/chart/MiniBar'
  import MiniProgress from '@/components/chart/MiniProgress'
  import RankList from '@/components/chart/RankList'
  import Bar from '@/components/chart/Bar'
  import LineChartMultid from '@/components/chart/LineChartMultid'
  import HeadInfo from '@/components/tools/HeadInfo.vue'

  import Trend from '@/components/Trend'
  import { getLoginfo,getVisitInfo } from '@/api/api'
  import { getAction,putAction } from '@/api/manage'

  const rankList = []
  const rankList2 = []
  
  const barData = []
  
  export default {
    name: "IndexChart",
    components: {
      ATooltip,
      ACol,
      ChartCard,
      MiniArea,
      MiniBar,
      MiniProgress,
      RankList,
      Bar,
      Trend,
      LineChartMultid,
      HeadInfo
    },
    data() {
      return {
        loading: true,
        center: null,
        rankList,
        rankList2,
        barData,
        loginfo:{},
        visitFields:['visit'],
        visitInfo:[],
        indicator: <a-icon type="loading" style="font-size: 24px" spin />,
        url:{
          //每月接单量统计
          queryDLPHB:"/feiyongtj/queryDLPHB",
          //维修员接单排行榜
          queryJDPHB:"/feiyongtj/queryJDPHB",
          //每月耗费统计
          queryHFPHB:"/feiyongtj/queryHFPHB",
          //材料耗材排行榜
          queryHCPHB:"/feiyongtj/queryHCPHB",
        },
      }
    },
    created() {
      setTimeout(() => {
        this.loading = !this.loading
      }, 1000)
      this.oneFun();
      this.twoFun();
      this.threeFun();
      this.fourFun();
      //this.initLogInfo();
    },
    methods: {
      oneFun(){
        getAction(this.url.queryDLPHB).then((res) => {
          if (res.success) {
            const barData = res.result
            for (let i = 0; i < 12; i += 1) {
              this.barData.push({
                x: `${i + 1}月`,
                y:Number(barData[i])
              })
            }
          }
        }).catch(error => {
          console.log("",error);
        });
      },
      //维修员接单排行榜 queryJDPHB
      twoFun(){
        getAction(this.url.queryJDPHB).then((res) => {
          if (res.success) {
            for (let i = 0; i < 7; i++) {
              this.rankList.push({
                name: res.result[i].wxAccount,
                total: res.result[i].count+'  单'
              })
            }
          }
        }).catch(error => {
          console.log("",error);
        });
      },
      //每月耗费统计
      threeFun(){
        getAction(this.url.queryHFPHB).then((res) => {
          if (res.success) {
            const resList = res.result
            for (let i = 0; i < 12; i += 1) {
              this.visitInfo.push({
                visit:Number(resList[i]),
                type:`${i + 1}月`
              })
            }
          }
        }).catch(error => {
          console.log("",error);
        });
      },
      //材料耗材排行榜
      fourFun(){
        getAction(this.url.queryHCPHB).then((res) => {
          if (res.success) {
            for (let i = 0; i < 7; i++) {
              this.rankList2.push({
                name: res.result[i].skuName,
                total: res.result[i].count +'  '+ res.result[i].spe
              })
            }
            
          }
        }).catch(error => {
          console.log("",error);
        });
      },
      initLogInfo () {
        getLoginfo(null).then((res)=>{
          if(res.success){
            Object.keys(res.result).forEach(key=>{
              res.result[key] =res.result[key]+""
            })
            this.loginfo = res.result;
          }
        })
        getVisitInfo().then(res=>{
          if(res.success){
             //this.visitInfo = res.result;
           }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .ant-card-body .canvas{margin-left:-30px !important}
  .circle-cust{
    position: relative;
    top: 28px;
    left: -100%;
  }
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }

  /* 首页访问量统计 */
  .head-info {
    position: relative;
    text-align: left;
    padding: 0 32px 0 0;
    min-width: 125px;

    &.center {
      text-align: center;
      padding: 0 32px;
    }

    span {
      color: rgba(0, 0, 0, .45);
      display: inline-block;
      font-size: .95rem;
      line-height: 42px;
      margin-bottom: 4px;
    }
    p {
      line-height: 42px;
      margin: 0;
      a {
        font-weight: 600;
        font-size: 1rem;
      }
    }
  }
</style>